import * as tts from "./common/tts";
var debug = false;
var searchParams = new URLSearchParams(window.location.search);
debug = searchParams.has('debug') ? !!searchParams.get('debug') : false;
var initAnalytics = function (context, segment) {
    var paywallElement = document.querySelector('.paywall-banner');
    if (!paywallElement) {
        debug && logDebug("Paywall banner isn't rendered. Aborting the analytics");
        return;
    }
    var main = document.querySelector('main');
    var route = main === null || main === void 0 ? void 0 : main.getAttribute('data-route');
    if (!route) {
        debug && logDebug('Can not retrieve route to initialize analytics, aborting');
        return;
    }
    sendPaywallHit('paywall_charged', segment, context, route);
    debug && logDebug("Added the analytics hit with the event: %c'paywall_charged'", 'font-style: italic; color: #DC3635');
    initAnalyticsView(paywallElement, segment, context);
    initAnalyticsClick(paywallElement, segment, context);
};
var initModalAnalytics = function (context, segment) {
    var _a;
    var route = (_a = document.querySelector('main')) === null || _a === void 0 ? void 0 : _a.getAttribute('data-route');
    if (!route) {
        debug && logDebug('Can not retrieve route to initialize the modal analytics, aborting');
        return;
    }
    sendPaywallHit('paywall_charged', segment, context, route);
    sendPaywallHit('paywall_view', segment, context, route);
    debug && logDebug("Paywall modal opened. Added the analytics hits with the events: %c'paywall_charged', 'paywall_view'", 'font-style: italic; color: #DC3635');
};
var sendPaywallHit = function (event, segment, context, route) {
    tts.custom({
        event: event,
        uri: document.location,
        utm_content: segment,
        utm_source: context,
    }, route);
};
var initAnalyticsView = function (paywallElement, segment, context) {
    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            var _a;
            if (entry.isIntersecting === false) {
                return;
            }
            observer.unobserve(entry.target);
            if (entry.target.isConnected === false) {
                debug && logDebug('Paywall banner was cleared before becoming visible. Aborting the analytics hit');
                return;
            }
            var route = (_a = document.querySelector('main')) === null || _a === void 0 ? void 0 : _a.getAttribute('data-route');
            if (!route) {
                debug && logDebug('Can not retrieve route to send the analytics hit, aborting');
                return;
            }
            debug && logDebug("Intersecting. Adding the analytics hit with the event: %c'paywall_view'", 'font-style: italic; color: #DC3635');
            sendPaywallHit('paywall_view', segment, context, route);
        });
    });
    observer.observe(paywallElement);
};
var initAnalyticsClick = function (paywallElement, segment, context) {
    var actionLink = paywallElement.querySelector('.btn');
    if (!actionLink) {
        return;
    }
    actionLink.addEventListener('click', function (e) {
        debug && logDebug("Action button fired. Adding the analytics hit with the event: %c'click'", 'font-style: italic; color: #DC3635');
        var isModifiedClick = e.ctrlKey || e.metaKey || e.shiftKey;
        var anchor = e.target.closest('a');
        var isTargetBlank = anchor && anchor.target === '_blank';
        var mustPreventDefault = !(isModifiedClick || isTargetBlank);
        if (mustPreventDefault) {
            e.preventDefault();
        }
        tts.click(actionLink.href, { utm_content: segment, utm_source: context, utm_campaign: 'paywall' })
            .then(function () {
            localStorage.setItem('pw_context', context);
            localStorage.setItem('pw_segment', segment);
            if (mustPreventDefault) {
                window.location.href = actionLink.href;
            }
        });
    });
};
var logDebug = function (message, context) {
    console.log("%cPaywall%c " + message, 'color: white; background-color: #8533ff; padding: 2px 5px; border-radius: 2px', 'color: auto; background-color: none; padding: none; border-radius: none', context !== null && context !== void 0 ? context : '');
};
export { initAnalytics, initModalAnalytics };
